export default "__VITE_ASSET__ffcac849__"